import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Login from '@/view/Public/login'


import Index from '@/view/Index/index'
import Project from '@/view/Project/list'//项目列表
import ProjectInfo from '@/view/Project/info'//项目详情

import Activitys from '@/view/Activity/list'//活动列表
import activityInfo from '@/view/Activity/info'//活动详情
import custom from '@/view/Activity/custom'//活动详情
import News from '@/view/News/list'//新闻列表
import NewsInfo from '@/view/News/info'//新闻详情
import fanbu from '@/view/News/fanbu'//反哺新闻
import aboutInfo from '@/view/News/aboutInfo'//关于我们
import organization from '@/view/News/organization'//关于我们
import organizationInfo from '@/view/News/organizationInfo'//关于我们
import userCenter from '@/view/Center/index'//个人中心
import centerHomeIndex from '@/view/Center/home/index'
import centerUserIndex from '@/view/Center/user/index'
import centerVisitIndex from '@/view/Center/visit/list'
import centercollegeStudentApply from '@/view/Center/college/apply'
import centerCollegeSupport from '@/view/Center/college/support'
import centerSupportUsers from '@/view/Center/user/support_user'
import centerActivityList from '@/view/Center/activity/list'
import centerActivityInfo from '@/view/Center/activity/info'
import volunteerAdd from '@/view/Center/user/volunteer'
import teacherInfo from '@/view/Center/user/teacherInfo'
import schoolInfo from '@/view/Center/user/schoolInfo'
import studentAccounts from '@/view/Center/user/studentAccounts'

//三级导航
Vue.use(Router)
const router =  new Router({
  mode: 'history',
  routes:[
    {
      path: '/',
      name:"home",
      component: Index,
      meta:{keepAlive:true,title:"顺丰公益基金会官网"}
    },
    {
      path:"/login",
      name:"login",
      component: Login,
      meta:{keepAlive:true,title:"用户登录"}
    },
    {
      path: '/news',
      name: 'news',
      component: News,
      meta:{keepAlive:true,title:"新闻列表"}
    },
    {
      path: '/newsInfo',
      name: 'newsInfo',
      component: NewsInfo,
      meta:{keepAlive:true,title:"新闻详情"}
    },
    {
      path: '/fanbu',
      name: 'fanbu',
      component: fanbu,
      meta:{keepAlive:true,title:"反哺计划"}
    },
    {
      path: '/aboutInfo',
      name: 'aboutInfo',
      component: aboutInfo,
      meta:{keepAlive:true,title:"新闻详情 —— 关于我们"}
    },
    {
      path: '/Organization',
      name: 'organization',
      component: organization,
      meta:{keepAlive:true,title:"志愿者协会"}
    },
    {
      path: '/OrganizationInfo',
      name: 'organizationInfo',
      component: organizationInfo,
      meta:{keepAlive:true,title:"志愿者协会详情"}
    },
    {
      path: '/projects',
      name: 'projects',
      component: Project,
      meta:{keepAlive:true,title:"项目列表"}
    },
    {
      path: '/projectInfo',
      name: 'projectInfo',
      component: ProjectInfo,
      meta:{keepAlive:true,title:"项目详情"}
    },
    {
      path: '/activitys',
      name: 'activitys',
      component: Activitys,
      meta:{keepAlive:true,title:"活动列表"}
    },
    {
      path:'/activityInfo',
      name:'activityInfo',
      component:activityInfo,
      meta:{keepAlive:true,title:"活动详情"}
    },
    {
      path:'/custom',
      name:'custom',
      component:custom,
      meta:{keepAlive:true,title:"活动报名填写"}
    },

    {
      path:'/userCenter',
      name:'userCenter',
      component:userCenter,
      meta:{title:'个人中心'},
      children:[
        {
          path:'/centerHomeIndex',
          name:'centerHomeIndex',
          component:centerHomeIndex,
          meta:{keepAlive:true,title:"个人中心"}
        },
        {
          path:'/centerUserIndex',
          name:'centerUserIndex',
          component:centerUserIndex,
          meta:{keepAlive:true,title:"个人中心"}
        },
        {
          path:'/centerActivityList',
          name:'centerActivityList',
          component:centerActivityList,
          meta:{keepAlive:true,title:"个人中心"}
        },
        {
          path:'/centerActivityInfo',
          name:'centerActivityInfo',
          component:centerActivityInfo,
          meta:{keepAlive:true,title:"个人中心-活动发起"}
        },
        {
          path:'/centerVisitIndex',
          name:'centerVisitIndex',
          component:centerVisitIndex,
          meta:{keepAlive:true,title:"个人中心"}
        },
        {
          path:"/centerCollegeStudentApply",
          name:'centerCollegeStudentApply',
          component:centercollegeStudentApply,
          meta:{keepAlive:true,title:"个人中心"}
        },
        {
          path:"/studentUniversity",
          name:'studentUniversity',
          //component:centerCollegeSupport,
          component: () => import('@/view/Center/college/support.vue'),
          meta:{keepAlive:false,title:"本专科奖学金"},
          props: { tableName: 'university' }
        },
        {
          path:"/studentMaster",
          name:'studentMaster',
          //component:centerCollegeSupport,
          component: () => import('@/view/Center/college/support.vue'),
          meta:{keepAlive:false,title:"硕士奖学金"},
          props: { tableName: 'master' }
        },
        {
          path:"/studentDr",
          name:'studentDr',
          component: () => import('@/view/Center/college/support.vue'),
          //component:centerCollegeSupport,
          meta:{keepAlive:false,title:"博士奖学金"},
          props: { tableName: 'dr' }
        },
        {
          path:"/volunteerAdd",
          name:'volunteerAdd',
          component:volunteerAdd,
          meta:{keepAlive:true,title:"个人中心"},
        },
        {
          path:'/centerSupportUsers',
          name:"centerSupportUsers",
          component:centerSupportUsers,
          meta:{keepAlive:true,title:"个人中心"}
        },
        {
          path:'/teacherInfo',
          name:"teacherInfo",
          component:teacherInfo,
          meta:{keepAlive:true,title:"个人中心"}
        },
        {
          path:'/schoolInfo',
          name:"schoolInfo",
          component:schoolInfo,
          meta:{keepAlive:true,title:"个人中心"}
        },
        {
          path:'/studentAccounts',
          name:"studentAccounts",
          component:studentAccounts,
          meta:{keepAlive:true,title:"个人中心"}
        }
      ]
    }
  ],
})
router.beforeEach((to,form,next)=>{
  if(to.meta.title){
    document.title = to.meta.p_title?to.meta.p_title:to.meta.title
  }
  let token = store.state.token
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  // window.pageYOffset = 0
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js